export enum UserGroupTypeEnum {
  PRODUCER = 'PRODUCER',
  AGENCY = 'AGENCY',
  SUPPLIER = 'SUPPLIER',
}
